import { Link } from "react-router-dom";

const SERVICES = [
  {
    num: "01",
    title: "Reklam Tabela",
    slug: "reklam-tabela",
    img: "/images/totemt/t.webp",
    desc: "Işıklı/ışıksız tabela, yönlendirme tabelası, özel tasarım ve kurumsal reklam tabela çözümleri.",
  },
  {
    num: "02",
    title: "Cephe Kaplama",
    slug: "cephe-kaplama",
    img: "/images/d/d-5.webp",
    desc: "Alüminyum kompozit, doğaltaş ve modern malzemelerle binalara estetik ve dayanıklı cephe kaplama çözümleri.",
  },
  {
    num: "03",
    title: "Kutu Harf Tabela",
    slug: "kutu-harf-tabela",
    img: "/images/b.webp",
    desc: "LED ışıklı, paslanmaz çelik ve alüminyum kutu harf tabela üretimi. Markanızı gece gündüz parlak tutun.",
  },
  {
    num: "04",
    title: "Totem Tabela",
    slug: "totem-tabela",
    img: "/images/totemt/t.webp",
    desc: "Park alanı, AVM girişi ve işyeri önü için dikkat çekici totem tabela tasarım ve üretimi.",
  },
  {
    num: "05",
    title: "Cafe & Restorant Dekorasyon",
    slug: "cafe-restorant-dekorasyon",
    img: "https://readdy.ai/api/search-image?query=modern%20cafe%20restaurant%20interior%20decoration%20vertical%20garden%20artificial%20plants%20wood%20stone%20warm%20lighting%20professional%20design%20Turkey%20cozy%20atmosphere&width=800&height=500&seq=svc_cafe_deko_02&orientation=landscape",
    desc: "Markanıza özel konsept tasarım, iç mekan dekorasyonu ve uygulama hizmetleri. Cafe, restoran, otel projeleri.",
  },
  {
    num: "06",
    title: "Işıklı Menü Board",
    slug: "isikli-menu-board",
    img: "/images/menu-icin-cephe-44a1019c.png",
    desc: "Işıklı ve ışıksız menü board uygulamaları ile ürünlerinizi dikkat çekici şekilde sergileyin.",
  },
  {
    num: "07",
    title: "Anahtar Teslim Proje",
    slug: "anahtar-teslim-proje",
    img: "https://readdy.ai/api/search-image?query=turnkey%20project%20delivery%20construction%20management%20professional%20team%20handover%20building%20facade%20signage%20complete%20solution%20Turkey%20commercial&width=800&height=500&seq=svc_anahtar_02&orientation=landscape",
    desc: "Tasarım, üretim, montaj ve bakım dahil tüm süreçleri tek elden yönetiyoruz. Anahtar teslim çözümler.",
  },
  {
    num: "08",
    title: "Grafik Tasarım",
    slug: "grafik-tasarim",
    img: "/images/neden-vip-reklam-806d6601.jpg",
    desc: "Logo, kurumsal kimlik, sosyal medya ve baskı materyalleri için profesyonel grafik tasarım hizmetleri.",
  },
];

interface ServiceRowProps {
  svc: (typeof SERVICES)[0];
  delay: number;
}

const ServiceRow = ({ svc, delay }: ServiceRowProps) => (
  <Link
    to={`/hizmetler/${svc.slug}`}
    className="flex items-center gap-5 py-5 border-b border-[#E8E8E8] cursor-pointer group anim-up"
    style={{ transitionDelay: `${delay * 80}ms` }}
  >
    <span className="font-head font-black text-5xl leading-none w-16 shrink-0 tr text-[#EBEBEB] group-hover:text-[#E6A800]">
      {svc.num}
    </span>
    <div className="w-10 h-10 flex items-center justify-center shrink-0 tr bg-[#F7F7F7] group-hover:bg-[#E6A800]">
      <i className="ri-arrow-right-up-line text-sm tr text-[#737373] group-hover:text-white" />
    </div>
    <div className="flex-1 min-w-0">
      <h3 className="font-head font-bold uppercase text-2xl md:text-3xl leading-none tr text-[#0D0D0D] group-hover:text-[#E6A800]">
        {svc.title}
      </h3>
      <p className="text-[#737373] text-xs mt-1 leading-snug hidden md:block truncate max-w-xl">
        {svc.desc}
      </p>
    </div>
    <div className="hidden lg:block w-[130px] h-14 overflow-hidden relative shrink-0">
      <img
        alt={svc.title}
        className="w-full h-full object-cover tr scale-110 opacity-0 group-hover:opacity-100 group-hover:scale-100"
        src={svc.img}
      />
    </div>
    <div
      className="w-10 h-10 flex items-center justify-center shrink-0 tr cursor-pointer bg-[#F7F7F7] text-[#737373] group-hover:bg-[#E6A800] group-hover:text-white"
      aria-label={svc.title}
    >
      <i className="ri-arrow-right-up-line text-sm" />
    </div>
  </Link>
);

const ServicesSection = () => (
  <section className="py-28 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-10 items-end mb-16">
        <div className="anim-left">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-[3px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">
              Uzmanlık Alanlarımız
            </span>
          </div>
          <h2 className="font-head font-black uppercase text-[#0D0D0D] text-6xl md:text-7xl leading-[0.9]">
            Hizmet
            <br />
            <span className="text-[#E6A800]">Kategorileri</span>
          </h2>
        </div>
        <p className="text-[#737373] text-sm leading-relaxed anim-right d2">
          Tasarımdan üretime, montajdan bakıma kadar tüm süreçleri kendi
          bünyemizde yönetiyoruz. Osmaniye ve çevresinde 20 yılı aşkın
          deneyimle hizmetinizdeyiz.
        </p>
      </div>

      <div className="border-t-2 border-[#0D0D0D]">
        {SERVICES.map((svc, i) => (
          <ServiceRow key={svc.num} svc={svc} delay={i} />
        ))}
      </div>

      <div className="mt-10 anim-up d7">
        <Link
          to="/hizmetler"
          className="inline-flex items-center gap-3 font-head font-700 uppercase tracking-wider text-sm text-[#737373] hover:text-[#E6A800] tr cursor-pointer group underline-grow"
        >
          Tüm hizmetleri incele
          <i className="ri-arrow-right-line group-hover:translate-x-1 tr" />
        </Link>
      </div>
    </div>
  </section>
);

export default ServicesSection;
